export function TrustpilotBadge() {
  return (
    <div className="trust-badge trust-badge--trustpilot">
      <span className="trust-badge__tp-stars">
        <svg width="116" height="22" viewBox="0 0 116 22" fill="none">
          {[0, 24, 48, 72].map(x => (
            <g key={x}>
              <rect x={x} y="1" width="20" height="20" rx="2" fill="#00b67a" />
              <path d={`M${x + 10} 4.5l2.2 4.5 4.9.7-3.5 3.5.8 4.9-4.4-2.3-4.4 2.3.8-4.9-3.5-3.5 4.9-.7z`} fill="#fff" />
            </g>
          ))}
          {/* Half star */}
          <defs>
            <clipPath id="tpHalfClip">
              <rect x="96" y="1" width="10" height="20" />
            </clipPath>
          </defs>
          <rect x="96" y="1" width="20" height="20" rx="2" fill="#dcdce6" />
          <rect x="96" y="1" width="20" height="20" rx="2" fill="#00b67a" clipPath="url(#tpHalfClip)" />
          <path d="M106 4.5l2.2 4.5 4.9.7-3.5 3.5.8 4.9-4.4-2.3-4.4 2.3.8-4.9-3.5-3.5 4.9-.7z" fill="#fff" />
        </svg>
      </span>
      <span className="trust-badge__tp-logo">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M20.4 8.8h-6.3L12 2.5 9.9 8.8H3.6l5.1 3.7-1.9 6.2L12 15l5.2 3.7-2-6.2z" fill="#00b67a" />
          <path d="M15.3 16l-.6-1.8L12 16.5l3.3-.5z" fill="#005128" />
        </svg>
        <span>Trustpilot</span>
      </span>
    </div>
  );
}

export default function TrustBadges() {
  return (
    <div className="trust-badges">
      <span className="trust-badges__label">Trusted by</span>
      <div className="trust-badges__row">
        <TrustpilotBadge />

        <span className="trust-badges__divider" />

        <span className="trust-badge__fdic">
          <svg width="56" height="26" viewBox="0 0 56 26" fill="none">
            <text x="28" y="9" fill="#6b7280" fontSize="7" fontWeight="400" fontFamily="system-ui, sans-serif" textAnchor="middle">Member</text>
            <text x="28" y="23" fill="#4b5563" fontSize="15" fontWeight="700" fontFamily="system-ui, sans-serif" textAnchor="middle" letterSpacing="-0.5">FDIC</text>
          </svg>
        </span>

        <span className="trust-badges__divider" />

        <span className="trust-badge__ssl">
          <svg width="22" height="26" viewBox="0 0 22 26" fill="none">
            <rect x="3" y="11" width="16" height="13" rx="2" fill="#6ab04c" />
            <path d="M7 11V7.5a4 4 0 118 0V11" stroke="#6ab04c" strokeWidth="2.5" fill="none" />
            <path d="M11 17l.8 2.5H10.2L11 17z" fill="#fff" />
            <circle cx="11" cy="16.5" r="1.5" fill="#fff" />
          </svg>
          <span className="trust-badge__ssl-text">
            <span className="trust-badge__ssl-secure">SECURE</span>
            <span className="trust-badge__ssl-sub">SSL ENCRYPTION</span>
          </span>
        </span>
      </div>
    </div>
  );
}
